export const getToastMessage = (response: any, error: boolean): any => {
  if (error) {
    if (response?.errors?.surveyTokenId) {
      return "El token no es válido";
    }
    if (response?.description) {
      return response?.description;
    }
    if (typeof response === "string") {
      const responseSplitted = response.split("$$");
      if (responseSplitted?.length) {
        return responseSplitted.map((item: string, index: number) => {
          return (
            <p>
              {index + 1}- {item}
            </p>
          );
        });
      }
      return response;
    }
    return "Hubo un error al procesar la solicitud";
  }
  return response?.data?.description || response?.data || response || "";
};
